import React, { useEffect, useRef, useState } from "react";
import DoctorAddBasicInfo from "./Large-forms/DoctorAddBasicInfo";
import { handleNext, handleBack } from "./Helper-Functions/DoctorStepperNav";
import { useFormik } from "formik";
import DoctorProfessionalInfo from "./Large-forms/DoctorProfessionalInfo";
import DoctorClinicDetails from "./Large-forms/DoctorClinicDetails";
import DoctorAddEduInfo from "./Large-forms/DoctorAddEduInfo";
import { useAddpatientMutation, useLazyGetpatientQuery } from "../State/Api/AddpatientApiSlice";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PatientBasicInfo from "./patientLarge-forms/PatientBasicInfo";
import PatientMedicalInfo from "./patientLarge-forms/PatientMedicalInfo";
import PatientVisitInfo from "./patientLarge-forms/PatientVisitInfo";
import PatientBillingInfo from "./patientLarge-forms/PatientBillingInfo";
import { useSearchParams } from "react-router-dom";
import { generateValidationSchema } from "./Validations";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaUser } from "react-icons/fa";
import { GoArrowLeft } from "react-icons/go";
import { Link} from "react-router-dom";
import { useLazyGetalldoctorsQuery } from "../State/Api/AdddocApiSlice";
import { v4 as uuidv4 } from 'uuid';

function PatientsStepper() {
  const [currentStep, setCurrentStep] = useState(1);
  const [searchParams, setSearchParams] = useSearchParams();


  

  const clinicUserId = localStorage.getItem("userClinicID");
  const [addpatient, { isSuccess, isError, isLoading, error }] =
    useAddpatientMutation();
  const [fetchPatient, { data: patientData, isFetching, failed }] =
    useLazyGetpatientQuery();
  const [fetchallDoctor, { data: alldoctorsData, isAdding, fail }] =
    useLazyGetalldoctorsQuery();
  const navigate = useNavigate();
  const params = useLocation();


  

  const formFields = [
    // "email",
    "fullname",
    "gender",
    "dateofbirth",
    // "phonenumber",
    "address",
    // "emergencycontactnumber",
    "patientid",
    "age",
    "martialstatus",
    // "emergencycontactname",
    // "relationtopatient",
    "addmissiontype",
    // "allergiesifany",
    "existingmedicalconditions",
    //  "refferedby",
    // "bloodgroup",
  // "bloodpressure",
  // "weight",
  // "height",
  // "pulse",
  "temparature",
    "dateofadmissionvisit",
    // "expecteddischarge",
    // "followupappointmentdate",
   
   
  ];
  const validationSchema = generateValidationSchema(formFields);
  const formik = useFormik({
    initialValues: {
      userclinicid: clinicUserId,
      email: "",
      fullname: "",
      gender: "",
      dateofbirth: "",
      phonenumber: "",
      address: "",
      emergencycontactnumber: "",
      patientid: "",
      age: "",
      martialstatus: "",
      emergencycontactname: "",
      relationtopatient: "",
      addmissiontype: "",
      primarydiagnosis: "",
      symptons: "",
      allergiesifany: null,
      existingmedicalconditions: null,
      assigneddoctor: "",
      treatmentplansummary: "",
      medicationsprescribed: "",
      labdiagnostictestsordered: "",
      roomwardnumber: "",
      dateofadmissionvisit: "",
      expecteddischarge: null,
      followupappointmentdate: null,
      insuranceprovider: "",
      insurancepolicynumber: "",
      billingstatus: "",
      paymentmethod: "",
      refferedby: "",
      bloodgroup: "",
      bloodpressure: "",
      weight: "",
      height: "",
      pulse: "",
      temparature: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => handleSubmit(values, { resetForm }),
  });

useEffect(() => {
  const generateEmail = () => {
    // Only generate email for NEW patients (not editing existing ones)
    if (!patientData && formik.values && !formik.values.email) {
      const uniqueId = uuidv4().split("-")[0]; // shorter UUID segment
      const generatedEmail = `user${uniqueId}@pelicanrx.com`;
      formik.setFieldValue("email", generatedEmail);
    }
  };

  generateEmail();
}, [patientData, formik.values]); // Add dependencies


const handleNext = async (currentStep, steps, setCurrentStep, formik) => {
  try {
    const errors = await formik.validateForm();

    const step1Fields = [
      "fullname",
      "gender",
      "dateofbirth",
      "phonenumber",
      "email",
      "emergencycontactname",
      "emergencycontactnumber",
      "relationtopatient",
      // "refferedby",
      "address",
      "age",
      "martialstatus",
      "addmissiontype",
      "allergiesifany",
      "existingmedicalconditions",
      "bloodgroup",
      "bloodpressure",
      "weight",
      "height",
      "pulse",
      "temparature",
     
    ];

    

    const firstErrorField = step1Fields.find((field) => !!errors[field]);

    if (!firstErrorField) {
      setCurrentStep(currentStep + 1);
    } else {
      
      formik.setTouched(
        step1Fields.reduce((acc, field) => {
          acc[field] = true;
          return acc;
        }, {}),
        true
      );

      
      toast.error(`${errors[firstErrorField]}`);
    }
  } catch (err) {
    console.error("Validation error:", err);
    toast.error("Validation failed.");
  }
};


const handleFinish = async () => {
  const errors = await formik.validateForm();

  if (Object.keys(errors).length === 0) {
    // Show confirmation alert first
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-confirm-modal">
            <div
              className="custom-confirm-box"
              style={{
                backgroundImage: "url('/Images/p2.png')",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
              }}
            >
              <button className="close-btn" onClick={onClose}>
                ×
              </button>
              <div className="icon-circle">?</div>
              <h2>Does this work for you?</h2>
              <p>
                {patientData
                  ? "Are You Sure Want To Update The Patient?"
                  : "Are You Sure Want To Add The Patient?"}
              </p>
              <div className="btn-group">
                <button className="btn-back px-4" onClick={onClose}>
                  Cancel
                </button>
                <button
                  className="gradient-button px-4"
                  onClick={() => {
                    formik.submitForm().then(() => {
                      onClose(); // close confirm dialog
                      confirmAlert({
                        customUI: ({ onClose }) => {
                          return (
                            <div
                              style={{
                                position: "fixed",
                                inset: 0,
                                background: "rgba(0, 0, 0, 0.2)",
                                zIndex: 9999,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <div
                                style={{
                                  position: "relative",
                                  background: "#fff",
                                  padding: "2.5rem 2rem",
                                  borderRadius: "1rem",
                                  maxWidth: "480px",
                                  width: "90%",
                                  textAlign: "center",
                                  backgroundImage: "url('/Images/p2.png')",
                                  backgroundSize: "cover",
                                  backgroundRepeat: "no-repeat",
                                  backgroundPosition: "center",
                                }}
                              >
                                <button
                                  onClick={onClose}
                                  style={{
                                    position: "absolute",
                                    right: "1rem",
                                    top: "1rem",
                                    background: "none",
                                    border: "none",
                                    fontSize: "2rem",
                                    color: "#6b7280",
                                    cursor: "pointer",
                                  }}
                                >
                                  ×
                                </button>
                                <div
                                  style={{
                                    fontSize: "3.5rem",
                                    color: "#3f51b5",
                                    marginBottom: "1rem",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <FaUser color="#A2AD91" />
                                </div>
                                <h2
                                  className="px-4"
                                  style={{
                                    fontSize: "1.25rem",
                                    fontWeight: 600,
                                    color: "#111827",
                                    marginBottom: "0.5rem",
                                  }}
                                >
                                  {patientData
                                    ? "The Patient Had Been Updated Successfully."
                                    : "The Patient Had Been Added Successfully."}
                                </h2>
                                <p
                                  className="px-4"
                                  style={{
                                    fontSize: "0.9rem",
                                    color: "#6b7280",
                                    marginBottom: "1.5rem",
                                  }}
                                >
                                  {patientData
                                    ? "All information about patient has been updated successfully"
                                    : "All information about patient has been added successfully"}
                                </p>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    gap: "1rem",
                                  }}
                                >
                                  <button
                                    onClick={() => {
                                      onClose();
                                      navigate("/ClinicPatients");
                                    }}
                                    className="gradient-dark-button w-100"
                                  >
                                    Back To Patient List
                                  </button>
                                  {patientData ? '' : (
  <button
    onClick={() => {
      onClose();
      const queryParams = new URLSearchParams(window.location.search);
      const ptntId = queryParams.get("redirectAppointmentId");

      console.log(ptntId);
      navigate(`/AddAppointment?ptntId=${ptntId}`, {
        state: {
          showModal: true,
          patientName: formik.values?.fullname,
          fromPatientView: true,
          patientUserUniqueID: ptntId,
        },
      });
    }}
    className="gradient-dark-button w-100"
  >
    Book an appointment
  </button>
)}

                                </div>
                              </div>
                            </div>
                          );
                        },
                      });
                    });
                  }}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        );
      },
    });
  } else {
    // Mark touched for validation styling
    formik.setTouched(
      Object.keys(errors).reduce((acc, field) => {
        acc[field] = true;
        return acc;
      }, {}),
      true
    );

    // Show toast for first error
    const firstFieldWithError = Object.keys(errors)[0];
    toast.error(`${errors[firstFieldWithError]}`);

    // Scroll to first error
    const el = document.querySelector(`[name="${firstFieldWithError}"]`);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
      el.focus();
    }
  }
};




  const formatDate = (dateString) => {
    if (!dateString || dateString === null || dateString === undefined || dateString === "") {
    return null;
  }
    const date = new Date(dateString);
    return date.toLocaleDateString("en-CA");
  };

 const handleSubmit = async (values, { resetForm }) => {
  const emergencyContact = values.emergencycontactnumber
    ? values.emergencycontactnumber.replace(/\D/g, '').slice(-10)
    : "";

  const contactNumber = values.phonenumber
    ? values.phonenumber.replace(/\D/g, '').slice(-10)
    : "";

  const value = {
    admissionvisitinfo: {
      dateofadmissionvisit: values?.dateofadmissionvisit,
      expecteddischargedate: values?.expecteddischarge,
      followupappointmentdate: values?.followupappointmentdate,
      userclinicid: clinicUserId,
    },
    basicInfo: {
      fullname: values?.fullname,
      userclinicid: clinicUserId,
      age: values?.age,
      dateofbirth: values?.dateofbirth,
      gender: values?.gender,
      martialstatus: values?.martialstatus,
      contactnumber: contactNumber,                // cleaned main contact number
      emailaddress: values?.email,
      address: values?.address,
      emergencycontactname: values?.emergencycontactname,
      emergencycontactnumber: emergencyContact,   // cleaned emergency contact number
      relationtopatient: values?.relationtopatient,
      refferedby: values?.refferedby,
    },
    insuranceinfo: {
      insuranceprovider: values?.insuranceprovider,
      userclinicid: clinicUserId,
      insurancepolicynumber: values?.insurancepolicynumber,
      billingstatus: values?.billingstatus,
      paymentmethod: values?.paymentmethod,
    },
    medicalinfo: {
      patientiduniqueid: values?.patientiduniqueid,
      addmissionType: values?.addmissiontype,
      userclinicid: clinicUserId,
      useruniqueid: localStorage.getItem("userUniqueID"),
      bloodGroup: values?.bloodgroup,
      bloodPressure: String(values?.bloodpressure ?? ""),
      weight: String(values?.weight ?? ""),
      height: String(values?.height ?? ""),
      pulse: String(values?.pulse ?? ""),
      temperature: String(values?.temparature ?? ""),
      allergies_ifany: values?.allergiesifany,
      existingMedicalConditions: values?.existingmedicalconditions,
    },
  };

  try {
    if (value) {
    
      const result = await addpatient(value).unwrap();
      const parsedResult =
        typeof result === "string" ? JSON.parse(result) : result;
        setSearchParams({ redirectAppointmentId: parsedResult?.login_UserId });
      if (parsedResult?.result_Code === 100) {
        toast.success("Submitted successfully");
        resetForm();
      } else if (parsedResult?.result_Code === 200) {
        // Handle other result code
      }
    }
  } catch (error) {
    toast.error("Your request could not be completed");
  
  }
};


  const Antdstyles = `
  .ant-upload-wrapper .ant-upload-select {
    width: 100% !important;
  }

  .ant-steps.ant-steps-vertical > .ant-steps-item .ant-steps-item-title {
    line-height: 14px !important;
  }



  .ant-steps-item-tail {
      padding: 42px 0 6px  !important;
  }

  :where(.css-dev-only-do-not-override-apn68).ant-steps.ant-steps-vertical >.ant-steps-item>.ant-steps-item-container>.ant-steps-item-tail::after {
      width: 4px;
  height: 47px;
  
  }

  :where(.css-dev-only-do-not-override-apn68).ant-steps.ant-steps-vertical >.ant-steps-item {
  margin-bottom: 3rem !important;
  }

  :where(.css-dev-only-do-not-override-apn68).ant-steps .ant-steps-item-finish .ant-steps-item-icon {
  background-color: #20ce78;
  border-color: #20ce78;
}

:where(.css-dev-only-do-not-override-apn68).ant-steps .ant-steps-item-finish .ant-steps-item-icon >.ant-steps-icon {
  color: #fff;
}

.anticon svg {

font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

:where(.css-dev-only-do-not-override-apn68).ant-steps .ant-steps-item-finish>.ant-steps-item-container>.ant-steps-item-tail::after {
  background-color: #20ce78;
}

.div-RCsYGZvZUN {

position: relative;
} 

/* Backdrop */
.custom-confirm-modal {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.2);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .custom-confirm-box {
    position: relative;
    background: #fff;
    padding: 2.5rem 2rem;
    border-radius: 1rem;
    max-width: 480px;
    width: 90%;
    text-align: center;
    background-image: url('/Images/p2.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }

  .custom-confirm-box .close-btn {
    position: absolute;
    right: 1rem;
    top: 1rem;
    background: none;
    border: none;
    font-size: 2rem;
    color: #6b7280;
    cursor: pointer;
  }

/* Icon */
.icon-circle {
  background-color: #e0ecff;
  color: #A2AD91;
  font-size: 1.5rem;
  font-weight: bold;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
}

/* Title */
.custom-confirm-box h2 {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #111827;
}

/* Message */
.custom-confirm-box p {
  font-size: 0.9rem;
  color: #6b7280;
  margin-bottom: 1.5rem;
}

/* Buttons */
.btn-group {
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.cancel-btn,
.confirm-btn {
  padding: 0.6rem 1.6rem;
  border-radius: 0.5rem;
  font-weight: 500;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.cancel-btn {
  background: #fff;
  border: 1px solid #d1d5db;
  color: #111827;
}

.confirm-btn {
  background: #2563eb;
  color: #fff;
  border: none;
}

.confirm-btn:hover {
  background: #1e40af;
}

/* Close Button (Top Right X) */
.close-btn {
  position: absolute;
  right: 1rem;
  top: 1rem;
  background: none;
  border: none;
  font-size: 2rem;
  color: #6b7280;
  cursor: pointer;
}
  
`;

 const { id: patientId } = useParams();
 const location=useLocation();

    const query = new URLSearchParams(location.search);
  const from = query.get("from"); 

    const handleMoveBack = () => {
    if (from) {
      navigate(from);
    } else {
   
      navigate(-1);
    }
  };

useEffect(() => {
  const showModal = params?.state?.showModal;
  const id = params?.state?.id;

  if (patientId) {
    fetchPatient(patientId); 
  } else if (showModal) {
    formik.resetForm();    
    setCurrentStep(1);     
  }
}, [patientId]);




  useEffect(() => {
    fetchallDoctor(clinicUserId); // Trigger fetch on mount
  }, [clinicUserId]);

useEffect(() => {
  if (patientData) {
    const addCountryCode = (num) => {
      if (!num) return "";
      
      return num.startsWith("+") ? num : `+91${num}`;
    };

    formik.setValues({
      email: patientData?.basicInfo?.emailaddress || "",
      fullname: patientData?.basicInfo?.fullname || "",
      age: patientData?.basicInfo?.age || "",
      gender: patientData?.basicInfo?.gender || "",
      dateofbirth: formatDate(patientData?.basicInfo?.dateofbirth) || "",
      martialstatus: patientData?.basicInfo?.martialstatus || "",
      phonenumber: addCountryCode(patientData?.basicInfo?.contactnumber),
      address: patientData?.basicInfo?.address || "",
      emergencycontactname: patientData?.basicInfo?.emergencycontactname || "",
      emergencycontactnumber: addCountryCode(patientData?.basicInfo?.emergencycontactnumber),
      relationtopatient: patientData?.basicInfo?.relationtopatient || "",
      refferedby: patientData?.basicInfo?.refferedby || "",
      addmissiontype: patientData?.medicalinfo?.addmissionType || "",
      allergiesifany: patientData?.medicalinfo?.allergies_ifany || "",
      existingmedicalconditions: patientData?.medicalinfo?.existingMedicalConditions || "",
      bloodgroup: patientData?.medicalinfo?.bloodGroup || "",
      bloodpressure: patientData?.medicalinfo?.bloodPressure || "",
      weight: patientData?.medicalinfo?.weight || "",
      height: patientData?.medicalinfo?.height || "",
      pulse: patientData?.medicalinfo?.pulse || "",
      temparature: patientData?.medicalinfo?.temperature || "",
      dateofadmissionvisit: formatDate(patientData?.admissionvisitinfo?.dateofadmissionvisit) || "",
      expecteddischarge: formatDate(patientData?.admissionvisitinfo?.expecteddischargedate) || null,
      followupappointmentdate: formatDate(patientData?.admissionvisitinfo?.followupappointmentdate) || null,
      insuranceprovider: patientData?.insuranceinfo?.insuranceprovider || "",
      insurancepolicynumber: patientData?.insuranceinfo?.insurancepolicynumber || "",
      billingstatus: patientData?.insuranceinfo?.billingstatus || "",
      paymentmethod: patientData?.insuranceinfo?.paymentmethod || "",
    });
  }
}, [patientData]);


  const customSubmit = (e) => {
    e.preventDefault();
  };

  const [draftEducation, setDraftEducation] = useState({
    _EductionhigherId: 0,
    EmployeeID: 0,
    highestQualification: "",
    university: "",
    fieldofstudy: "",
    certifications: "",
    percentage: "",
    startDate: "",
    endDate: "",
  });

  const [editEducationIndex, setEditEducationIndex] = useState(null);

  function handleRemoval(type, index) {
    if (type === "education") {
      const mutatededucation = formik.values.employee_Heighers.filter(
        (experience, index) => index !== editEducationIndex
      );
      formik.setFieldValue("employee_Heighers", mutatededucation);
      setEditEducationIndex(mutatededucation?.length - 1);
    }
  }

  const steps = [
    {
      content: (
        <>
          <PatientBasicInfo formik={formik} clinicUserId={clinicUserId}/>

          <PatientMedicalInfo formik={formik} />
        </>
      ),
    },

    {
      content: (
        <>
          <PatientVisitInfo formik={formik} />

          {/* <PatientBillingInfo formik={formik} /> */}
        </>
      ),
    },
    // {
    //   title: "Work Experience",
    //   content: (
    //     <>
    //       <DoctorAddBasicInfo formik={formik} />
    //       {/* <EmployeeAddWorkExp
    //         workExpVars={{
    //           placehOlderWorkExp,
    //           setPlaceHolderWorkExp,
    //           formik,
    //           editExpIndex,
    //           setEditExpIndex,
    //           employeeData,
    //           handleRemoval,
    //         }}
    //       />
    //      */}
    //       <DoctorAddBasicInfo formik={formik} />
    //       {/* <EmployeeAddProjectsInfo
    //         projectVars={{
    //           draftProject,
    //           setDraftProject,
    //           editProjectIndex,
    //           setEditProjectIndex,
    //           formik,
    //           employeeData,
    //           handleRemoval,
    //         }}
    //       /> */}
    //     </>
    //   ),
    // },
  ];

  const progressWidth = (currentStep / steps.length) * 100;

  let content = null;

  content = (
    <>
      <style>{Antdstyles}</style>
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="col-12 col-md-12 col-lg-12 col-xl-12 mb-3">
        
                  <button className="bg-[#fff] inline-flex items-center justify-center shrink-0 gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border border-input bg-background hover:bg-accent hover:text-accent-foreground size-10" onClick={handleMoveBack}>
                    <GoArrowLeft />
                    <span className="sr-only">Back</span>
                  </button>
        <div className="card">
          {/* Progress Bar */}
          <div className="progress" style={{ height: "6px" }}>
            <div
              className="progress-bar"
              role="progressbar"
              style={{ width: `${progressWidth}%`,backgroundColor:'#A2AD91' }}
              aria-valuenow={progressWidth}
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>

          {/* Step Content */}

          <form onSubmit={customSubmit}>
            {steps[currentStep - 1].content}

            {/* Navigation Buttons */}
            <div
  className={`d-flex mt-3 ${
    currentStep === 1 ? "justify-content-end" : "justify-content-between"
  }`}
>
  {currentStep !== 1 && (
    <button
      className="gradient-dark-button px-4"
      onClick={() => handleBack(currentStep, setCurrentStep)}
      type="button"
    >
      Back
    </button>
  )}

  <button
    className="gradient-button px-4"
    onClick={
      currentStep === steps.length
        ? handleFinish 
        : () => handleNext(currentStep, steps, setCurrentStep, formik)
    }
    type="button"
    disabled={formik.isSubmitting}
  >
    {currentStep === steps.length ? "Finish" : "Next"}
  </button>
</div>
          </form>
        </div>
      </div>
    </>
  );

  return content;
}

export default PatientsStepper;
